<template>
  <div>
    <div
      class="mb-4"
      style="text-align: right"
    >
      <span>
        <button
          v-b-tooltip.hover
          v-b-modal.createNewEdition
          type="button"
          placement="bottom"
          title="Neue Edition erstellen"
          class="btn btn-success"
          @click="popupVisible = true"
        >
          <i class="fas fa-plus" />
        </button>
      </span>
    </div>

    <b-modal
      id="createNewEdition"
      ref="createNewEdition"
      hide-footer
      title="Neue Edition erstellen"
      no-fade
      :no-close-on-backdrop="isLoading"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <u-loader
          v-if="isLoading"
          text="Die Edition wird erstellt. Das kann eine Weile dauern..."
        />
        <VersionEditionSelection
          v-else
          v-model="selection"
          :current-contract-number="contractId"
          :current-version-number="versionNumber"
          :current-edition-id="editionId"
        />
      </div>
      <b-button
        variant="success"
        :disabled="isLoading"
        @click="createNewEdition"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant
        :disabled="isLoading"
        @click="hideModal"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import VersionEditionSelection from "@/components/contract/version/VersionEditionSelection.vue";
import { CloneEdition } from "@/services/contract.edition.service.js";

export default {
  components: {
    VersionEditionSelection,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionNumber: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selection: {
        VersionId: -1,
        EditionId: -1,
        CopyMindestlohn: 1,
      },
      errorObject: null,
      isLoading: false,
      popupVisible: false,
    };
  },
  methods: {
    hideModal() {
      this.$refs["createNewEdition"].hide();
    },
    createNewEdition() {
      this.isLoading = true;

      CloneEdition(
        this.contractId,
        this.versionNumber,
        this.selection.EditionId,
        this.selection.CopyMindestlohn,
        this.selection.MiloSalaryImport,
        (response) => {
          this.$router.push({
            path: `/contract-overview/${this.contractId}/${this.versionNumber}/${response.data}`,
            quey: { source: this.$route.path },
          });
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped></style>
